import { ActivityLogParser } from '@/parsers/activityLog'
import { i18n } from '@/i18n'
import { kebabCase } from 'lodash'

export class ConsultingFileActivityLogParser extends ActivityLogParser {
    static attributeDataTypes = {
        'type.key': 'consultingFileType',
    }

    static getLogDescriptionUpdated (activityLog, data) {
        const interpolationParams = {
            someone: data.causer,
            something: `<b>${i18n.tc('common.change-log.subject.some.consulting-file', 1)}</b>`,
        }
        if (data.causer) {
            return i18n.t('common.change-log.someone-updated-something', interpolationParams)
        } else {
            return i18n.t('common.change-log.something-has-been-updated', interpolationParams)
        }
    }

    static showLogDetailsCreated = true
    static showLogDetailsDeleted = true
}
